import React, { useEffect, Fragment } from "react";
import { useDispatch } from "react-redux";
import Slider from "../../components/Slider";
import SliderModels from "../../components/SliderModels";
import Stage from "../../components/Stage";
import Header from "../../components/layout/Header";
import Banner from "../../components/Banner";

import {
  getCategoriasR as getCats,
  getAllArticulos as getArts,
  getSubCategoriasR as getSubCats,
  jsonDeserialize,
} from "../../API/request";
import Loading from "../../components/Loading";
import MainStage from "../../components/MainStage";
import CollectionStage from "../../components/CollectionStage";

import { fetchArts } from "../../redux/slices/articulosSlice";

const Home = () => {
  const showPrice = process.env.REACT_APP_SHOW_PRICE === "false" ? false : true;
  const showBanner =
    process.env.REACT_APP_SHOW_BANNER === "false" ? false : true;

  const [showLoading, setShowLoading] = React.useState(true);
  const [listadoCategorias, setListadoCategorias] = React.useState(null);

  const [listadoNuevos, setListadoNuevos] = React.useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchArts());
  }, [dispatch]);

  useEffect(() => {
    document.title = "Home";
    window.scrollTo(0, 0);

    setListadoCategorias(null);
    setListadoNuevos([]);

    var generalNuevos = [];

    getCats()
      .then(async(responseCategorias) => {
        let cats = jsonDeserialize(responseCategorias.data.data).data;
        const articulosConContador = await Promise.all(
          cats.map(async (modelo) => {
            try {
              const res = await getSubCats(modelo.idCategoria);
              const subCatsRaw = res?.data?.data;
              const subCats = jsonDeserialize(subCatsRaw).data;
              return {
                ...modelo,
                contadorArticulos: subCats.length,
              };
            } catch (error) {
              console.error(`Error con ${modelo.nombre}`, error);
              return {
                ...modelo,
                contadorArticulos: 0,
              };
            }
          })
        );
      
        const getPriority = (nombre) => {
          const lower = nombre.toLowerCase();
          if (lower.startsWith("e-tron")) return 0;
          if (lower.startsWith("q") && lower.includes("e-tron")) return 1;
          if (/^a[1-8]$/.test(lower)) return 2;
          if (lower.startsWith("q")) return 3;
          return 4;
        };
      
        const ordenados = [...articulosConContador].sort((a, b) => {
          const pA = getPriority(a.nombre);
          const pB = getPriority(b.nombre);
      
          if (pA !== pB) return pA - pB;
          return a.nombre.localeCompare(b.nombre);
        });
      
        setListadoCategorias(ordenados);

        getArts()
          .then((responseArticulos) => {
            var arts = jsonDeserialize(responseArticulos.data.data).articulos
              .data;
            var item_generalNuevos = arts.filter(
              (item) => item.nuevo === "True"
            );

            generalNuevos.push.apply(generalNuevos, item_generalNuevos);

            setListadoNuevos(generalNuevos);
            setShowLoading(false);
            window.scrollTo(0, 0);
          })
          .catch((errorMessageGetMantenimiento) => {
            console.log("ERORR - En la petición");
          });
      })
      .catch((errorMessageGetMantenimiento) => {
        console.log("ERORR - En la petición");
      });
  }, [setShowLoading, setListadoCategorias, setListadoNuevos]);

  return (
    <Fragment>
      {showLoading ? (
        <Loading />
      ) : (
        <>
          <Header />
          <div className="content">
            <MainStage />

            <SliderModels title="Modelos" articulos={listadoCategorias} />

            {showBanner && <Banner />}

            <div className="row row-cols-3">
              <CollectionStage image={"/banner/acc_diseno.jpg"} />
              <CollectionStage image={"/banner/acc_transporte.jpg"} />
              <CollectionStage image={"/banner/acc_proteccion.jpg"} />
            </div>

            <Stage image={"banner/acc_diseno.jpg"} />
            <Stage image={"banner/acc_transporte.jpg"} />
            <Stage image={"banner/acc_proteccion.jpg"} />

            {listadoNuevos.length > 0 && (
              <Slider
                title="Nuevos"
                articulos={listadoNuevos}
                showPrice={showPrice}
              />
            )}
          </div>
        </>
      )}
    </Fragment>
  );
};

export default Home;
